import shortid from 'shortid';
import './assets/parent.scss';
import { Draggable } from './Library';

export default class Builder {
  constructor(eventBus) {
    this.zoom = 1;
    this.menus = [];
    this.eventBus = eventBus;
  }

  addMenu(config) {
    const menu = {
      placeholderTag: config.placeholderTag || 'div',
      type: config.type,
      menuSelector: config.menu,
      title: config.title,
      containerSelector: config.type === 'blocks' ? '#blocks-container' : '[data-gp-container]',
      draggableAttribute: config.type === 'blocks' ? 'data-gp-block' : 'data-gp-dnd',
      draggableClass: config.type === 'blocks' ? 'frame-drag-block' : 'frame-drag-element',
      menuContainers: [],
      controller: new Draggable([], {
        draggable: config.menuDraggable,
        distance: 10,
        mirror: {
          appendTo: 'body'
        }
      })
    };
    const index = _.findIndex(this.menus, { menuSelector: config.menu });
    this.menus.splice(index, index > -1 ? 1 : 0, menu);
    this.setupListeners(menu);
    this.refresh();
    return menu.controller;
  }

  linkFrame(frame) {
    this.frame = frame;
  }

  setupListeners(menu) {
    menu.controller.on('drag:start', (sensorEvent) => {
      if (menu.type === 'elements') {
        const dropzone = this.frame.contentDocument.querySelector(
          '[data-gp-container]'
        );
        if (!dropzone) {
          const id = shortid.generate();
          const block = `
            <section class="gp-block-init" data-gp-block="true" data-gp-block-data="{}" data-gp-component="block" data-gp-style>
              <div data-section-overlay></div>
              <div class="gp-component-id-${id} container" data-gp-container data-gp-style></div>
            </section>
          `;
          const blocksContainer = this.frame.contentDocument.getElementById(
            'blocks-container'
          );
          blocksContainer.insertAdjacentHTML('beforeend', block);
          this.refresh();
        }
      }
      const placeholder = document.createElement(menu.placeholderTag);
      placeholder.setAttribute(menu.draggableAttribute, true);
      placeholder.classList.add(menu.draggableClass);
      const container = this.frame.contentWindow.document.querySelectorAll(
        menu.containerSelector
      )[0];
      // fire bus event before sensor event so placeholder can me modified
      const event = {
        menuItem: sensorEvent.source,
        placeholder,
        type: menu.type,
        event: sensorEvent,
      };
      this.eventBus.$emit('select-element-request', null);
      this.eventBus.$emit('drag:start', event);
      this.frame.contentWindow.dragdropMessenger(
        sensorEvent,
        container || document.createElement('div'),
        event.placeholder
      );
    });
    menu.controller.on('drag:move', (sensorEvent) => {
      const container = this.frame.contentWindow.document.querySelectorAll(
        menu.containerSelector
      )[0];
      this.frame.contentWindow.dragdropMessenger(
        sensorEvent,
        container || document.createElement('div')
      );
      this.DragDropTarget = sensorEvent.originalEvent.target;
      this.eventBus.$emit('drag:move', {
        menuItem: sensorEvent.source,
        type: menu.type,
        event: sensorEvent,
      });
    });
    menu.controller.on('drag:stop', (sensorEvent) => {
      const container = this.frame.contentWindow.document.querySelectorAll(
        menu.containerSelector
      )[0];
      this.frame.contentWindow.document
        .querySelectorAll(`.${menu.draggableClass}`)
        .forEach((placeholder) => {
          placeholder.classList.remove(menu.draggableClass);
        });
      this.frame.contentWindow.dragdropMessenger(
        sensorEvent,
        container || document.createElement('div')
      );
      this.eventBus.$emit('drag:stop', {
        menuItem: sensorEvent.source,
        dropped:
          this.DragDropTarget &&
          this.DragDropTarget.hasAttribute('data-canvas-frame-overlay') &&
          container,
        type: menu.type,
        event: sensorEvent,
      });
      this.refresh();
    });
    menu.controller.on('mirror:attached', (event) => {
      this.eventBus.$emit('mirror:attached', {
        mirror: event.mirror,
        type: menu.type,
        event,
      });
    });
  }

  refresh() {
    this.menus.forEach(this.refreshMenu);
    this.frame.contentWindow.dragdropMessenger && this.frame.contentWindow.dragdropMessenger('contentChange');
  }

  refreshMenu(menu) {
    menu.menuContainers.forEach((container) => menu.controller.removeContainer(container));
    menu.menuContainers = document.querySelectorAll(menu.menuSelector);
    menu.menuContainers.forEach((container) => menu.controller.addContainer(container));
  }

  setZoom() {
    const transform = `scale(${1 / this.zoom}) translateY(-${
      50 * (this.zoom - 1)
    }%)`;
    this.frame.contentWindow.document.body.style.transform = transform;
    this.frame.contentWindow.document.body.setAttribute(
      'data-gp-zoom',
      this.zoom
    );
  }

  zoomOut() {
    this.zoom++;
    this.setZoom();
  }

  zoomIn() {
    if (this.zoom > 1) {
      this.zoom--;
      this.setZoom();
    }
  }
}
